module.exports = __webpack_public_path__ + "static/media/watch_nav_compare.7cdd1ba0.svg";